<div class="flex flex-column gap-0 message-information-modal">
    @if (message.image) {
        <div class="message-information-modal__image">
            <img
                [src]="message.image"
                alt=""
                class="w-full object-cover" />
        </div>
    }

    <div class="p-4 flex flex-column gap-3">
        @if (message.titre) {
            <h2 class="text-xl font-semibold m-0 text-color">{{ message.titre }}</h2>
        }

        <sihc-quill-view
            [modules]="sdb.modules"
            [content]="message.message"
            [style]="quillViewStyle" />

        <div class="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3 pt-2 border-top-1 surface-border">
            @if (message.dateCreation) {
                <span class="text-sm text-color-secondary order-2 sm:order-1">
                    {{ dateCreationFormatee() }}
                </span>
            }

            <div class="flex align-items-center justify-content-end gap-3 flex-wrap order-1 sm:order-2 ml-auto">
                @if (message.indDismissable) {
                    <div class="flex align-items-center gap-2">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="nePlusAfficher"
                            inputId="message-info-ne-plus-afficher"
                            (onChange)="onNePlusAfficherChange($event.checked)" />
                        <label
                            for="message-info-ne-plus-afficher"
                            class="text-sm mb-0 cursor-pointer text-color-secondary">
                            Ne plus afficher
                        </label>
                    </div>
                }

                <p-button
                    label="Fermer"
                    icon="pi pi-times"
                    (onClick)="fermer()" />
            </div>
        </div>
    </div>
</div>
